// extracted by mini-css-extract-plugin
module.exports = {"container":"_1hfhr9da7ah4hRTYVUgWA6","charity":"L2hJFdK2IwF7nKk3GpIq8","title":"_25bhfHavvbGkQ8wF9PEaDW","tag":"_1lWqZHDRiIx3j-Xg8wHf4V"};